import { React, useState } from 'react';
import "./index.scss";
import champLogo from "../../assets/images/subscription/champLogo.png";
import vector from "../../assets/images/subscription/Vector.png";
import bgImage from "../../assets/images/subscription/bgImg.png";
import { Button } from '@mui/material';
import { useMediaQuery } from "@mui/material";

const SubsCription = () => {

    const [activePlan, setActivePlan] = useState(null);
    const mobileView = useMediaQuery("(max-width:769px)")

    const handlePlanClick = (plan) => {
        setActivePlan(plan);
    };

    const getColumnBackground = (plan) => {
        return activePlan === plan ? "linear-gradient(180deg, rgba(148, 188, 255, 0.0825) 0%, rgba(148, 188, 255, 0) 100%)" : "transparent";
    };

    const getHeadingColor = (plan) => {
        return activePlan === plan ? "#46ef09" : "#94bcff4d"
    };

    const getButtonText = () => {
        if (!activePlan) {
            return <span>Select a Plan &raquo;</span>;
        }
        return <span>Continue with <strong>{activePlan}</strong> &raquo;</span>;
    };

    const benefitsTag = [
        "All brand deals at 15% off",
        "Exclusive cash deals",
        "Runs back on transactions",
        "Happy hour runs",
        "Job postings & applying",
        "Promotion across website",
        "Additional returns in games",
        "Member only sessions",
        "Exclusive summer camps",
        "Early access to deals",
        "Performance camps"
    ];

    const plans = [
        {
            name: "T20",
            benefits: ["&#10003;", "&#10003;", "10%", "1.5x", "FREE", "1/M", "&#10003;", "&#10005;", "&#10005;", "&#10005;", "&#10005"]
        },
        {
            name: "ODI",
            benefits: ["&#10003;", "&#10003;", "10%", "1.5x", "FREE", "1/M", "&#10003;", "&#10003;", "&#10003;", "&#10003;", "&#10003;"]
        },
        {
            name: "TEST",
            benefits: ["&#10003;", "&#10003;", "10%", "2x", "FREE", "1/M", "&#10003;", "&#10003;", "&#10003;", "&#10003;", "&#10003;"]
        }
    ];

    return (
        <div className='sub-main-container'>
            {mobileView && (
                <div className='mobileView-container'>
                    <div className='logo-and-text-mobile'>
                        <img className='champ-logo-mobile' src={champLogo} alt='logo' />
                        <img className='champ-name-mobile' src={vector} alt='Champhunt' />
                    </div>
                    <h4 className='heading-text-logo-mobile'>Unleash your real fun</h4>
                </div>
            )}
            <div className='sub-inner-container'>
                <div className='sub-left-container'>
                    <div className='logo-and-text'>
                        <img className='champ-logo' src={champLogo} alt='logo' />
                        <img className='champ-name' src={vector} alt='Champhunt' />
                    </div>
                    <h4 className='heading-text-logo'>Unleash your real fun</h4>
                    <div className='bgImg-container'>
                        <img className='bgImage' src={bgImage} alt='backgroundImg' />
                    </div>
                </div>
                <div className='sub-right-container'>
                    <table>
                        <colgroup>
                            <col className="column-details" />
                            <col className='column-bg' style={{ background: getColumnBackground('T20') }} />
                            <col className='column-bg' style={{ background: getColumnBackground('ODI') }} />
                            <col className='column-bg' style={{ background: getColumnBackground('TEST') }} />
                        </colgroup>
                        <thead>
                            <tr>
                                <th className='heading-text-main-col'>
                                    PICK A PLAN
                                    <p className='heading-small'>Deals, Runs, Jobs,<br></br>Promotions Etc.</p>
                                </th>
                                <th
                                    className='heading-text-category-col'
                                    onClick={() => handlePlanClick('T20')}
                                    style={{ color: getHeadingColor('T20') }}
                                >
                                    T20
                                </th>
                                <th
                                    className='heading-text-category-col'
                                    onClick={() => handlePlanClick('ODI')}
                                    style={{ color: getHeadingColor('ODI') }}
                                >
                                    ODI
                                </th>
                                <th
                                    className='heading-text-category-col'
                                    onClick={() => handlePlanClick('TEST')}
                                    style={{ color: getHeadingColor('TEST') }}
                                >
                                    TEST
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {benefitsTag.map((benefit, index) => (
                                <tr key={index}>
                                    <td className='list-text-main-col'>{benefit}</td>
                                    {plans.map(plan => (
                                        <td className='list-text-category-col' key={plan.name} dangerouslySetInnerHTML={{ __html: plan.benefits[index] }}></td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='btn-container'>
                <div className='btn-inner-container'>
                    {['T20', 'ODI', 'TEST'].map((category, index) => (
                        <div
                            className={`btn-plan ${activePlan === category ? 'active' : ''}`}
                            key={category}
                            onClick={() => handlePlanClick(category)}
                        >
                            <p className='category-text'>{category}</p>
                            <div className='btn-inner-container2'>
                                <p className='plan-text'>
                                    &#8377;{[50, 100, 200][index]}
                                    <small>/{[3, 6, 12][index]}Months</small>
                                </p>
                                <del className='discount-text'>&#8377;{[60, 120, 240][index]}</del>
                            </div>
                        </div>
                    ))}
                </div>
                <Button className='btn-continue'>
                    {getButtonText()}
                </Button>
            </div>
        </div>
    );
}

export default SubsCription;